import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SettingSection = ({ title, children }) => {
    return (_jsxs("div", { className: "mb-10", children: [_jsx("h3", { className: "hidden", children: title }), children] }));
};
export default SettingSection;
